import React from 'react';
import { diffWords } from 'diff';
import PropTypes from 'prop-types';
import { DiffPart } from './styles';

/**
 * DiffViewer Component
 *
 * Props:
 * - oldText: string
 * - newText: string
 * - diffType: string ('words', 'chars', 'lines')
 *
 * Usage:
 * <DiffViewer oldText="old text" newText="new text" />
 */
export default function DiffViewer({ oldText, newText, diffType = 'words' }) {
  // Choose diff function based on diffType
  const getDiffs = () => {
    switch (diffType) {
      case 'chars':
        return require('diff').diffChars(oldText || '', newText || '');
      case 'lines':
        return require('diff').diffLines(oldText || '', newText || '');
      case 'words':
      default:
        return diffWords(oldText || '', newText || '');
    }
  };

  const differences = getDiffs();

  return (
    <span>
      {differences.map((part, index) => {
        return (
          <DiffPart key={index} added={part.added} removed={part.removed}>
            {part.value}
          </DiffPart>
        );
      })}
    </span>
  );
}

DiffViewer.propTypes = {
  oldText: PropTypes.string.isRequired,
  newText: PropTypes.string.isRequired,
  diffType: PropTypes.oneOf(['words', 'chars', 'lines']),
};
